import { createContext, useContext, useEffect, useState } from "react";
import { LANGS, translations } from "./translations";

const STORAGE_KEY = "vimmerbyferie-lang";
const LangContext = createContext(null);

const initialLang = () => {
  const saved = window.localStorage.getItem(STORAGE_KEY);
  return LANGS.includes(saved) ? saved : "sv";
};

const setMeta = (name, content) => {
  const el = document.querySelector(`meta[name="${name}"]`);
  if (el) el.setAttribute("content", content);
};

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(initialLang);
  const t = translations[lang];

  useEffect(() => {
    window.localStorage.setItem(STORAGE_KEY, lang);
    document.documentElement.lang = lang;
    document.title = t.meta.title;
    setMeta("description", t.meta.description);
  }, [lang, t]);

  return <LangContext.Provider value={{ lang, setLang, t }}>{children}</LangContext.Provider>;
};

export const useLang = () => useContext(LangContext);
